// services/moduleService.js
import api from "./api";

export const getAllModules = async () => {
  try {
    const response = await api.get("/modules/");
    return response.data;
  } catch (error) {
    console.error("Error fetching modules:", error);
    throw error;
  }
};

export const getModuleById = async (moduleId) => {
  try {
    const response = await api.get(`/modules/${moduleId}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching module with ID ${moduleId}:`, error);
    throw error;
  }
};

export const createModule = async (moduleData) => {
  try {
    const response = await api.post("/modules/", moduleData);
    return response.data;
  } catch (error) {
    console.error("Error creating module:", error);
    throw error;
  }
};

export const updateModule = async (moduleId, moduleData) => {
  try {
    const response = await api.put(`/modules/${moduleId}/`, moduleData);
    return response.data;
  } catch (error) {
    console.error(`Error updating module with ID ${moduleId}:`, error);
    throw error;
  }
};

export const deleteModule = async (moduleId) => {
  try {
    await api.delete(`/modules/${moduleId}/`);
  } catch (error) {
    console.error(`Error deleting module with ID ${moduleId}:`, error);
    throw error;
  }
};

// Optional: Add pagination support
export const getModulesWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  ordering = "-created_at",
  status = null,
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    if (status) params.append("status", status);

    const response = await api.get("/modules/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching modules with pagination:", error);
    throw error;
  }
};

// Optional: Add bulk operations
export const bulkCreateModules = async (modulesData) => {
  try {
    const response = await api.post("/modules/bulk-create/", modulesData);
    return response.data;
  } catch (error) {
    console.error("Error bulk creating modules:", error);
    throw error;
  }
};

export const bulkUpdateModules = async (modulesData) => {
  try {
    const response = await api.put("/modules/bulk-update/", modulesData);
    return response.data;
  } catch (error) {
    console.error("Error bulk updating modules:", error);
    throw error;
  }
};

// Optional: Add module status check
export const getModuleStatus = async (moduleId) => {
  try {
    const response = await api.get(`/modules/${moduleId}/status/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching status for module ${moduleId}:`, error);
    throw error;
  }
};
